"use strict";
exports.__esModule = true;
var MESSAGE_COOKIE_KEY = 'read_messages';
var INTERVAL_TIME_MILLISEC = 60000;
var ERROR_MESSAGE = 'danger';
var CryptoJS = require('crypto-js');
function BroadcastMessageViewContrller($scope, $cookies, $http, $timeout) {
    var ctrl = this;
    var intervalHanles = [];
    ctrl.$onInit = function () {
        pollMessages();
    };
    ctrl.$onDestroy = function () {
        clearTimers();
    };
    function clearTimers() {
        for (var _i = 0, intervalHanles_1 = intervalHanles; _i < intervalHanles_1.length; _i++) {
            var t = intervalHanles_1[_i];
            clearInterval(t);
        }
    }
    function showAlert(type, title, message) {
        if (ctrl.showAlert) {
            ctrl.showAlert({ type: type, title: title, message: message });
        }
        else {
            alert(title + '\n' + message);
        }
    }
    ctrl.messages = {
        list: []
    };
    ctrl.markAllAsRead = function () {
        readMsgs();
    };
    function readMsgs() {
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + 365); // Set cookie expiration to 1 year
        var idsWithHashes = ctrl.messages.list
            .map(function (m) {
            var concatenatedMessage = m.message + m.title; // Combine message and title
            var hash = generateHashSync(concatenatedMessage); // Generate hash based on concatenated message
            m.hasRead = true; // Mark message as read
            return m._id + "#" + hash; // Store `_id` and hash
        })
            .join(':');
        // Store the `_id#hash` pairs in the cookie
        $cookies.put(MESSAGE_COOKIE_KEY, encodeURIComponent(idsWithHashes), { expires: expireDate });
    }
    // function readMsgs() {
    //     ctrl.messages.list.forEach((m) => {
    //         m.hasRead = true;
    //     });
    //     const expireDate = new Date();
    //     expireDate.setDate(expireDate.getDate() + 365);
    //     const ids = ctrl.messages.list.map(m => m._id).join(':');
    //     $cookies.put(MESSAGE_COOKIE_KEY,
    //         encodeURIComponent(ids), { 'expires': expireDate });
    // }
    // function getReadMsgs() {
    //     const ids = $cookies.get(MESSAGE_COOKIE_KEY);
    //     if (!ids) {
    //         return '';
    //     }
    //     return decodeURIComponent(ids);
    // }
    function getReadMsgs() {
        var idsWithHashes = $cookies.get(MESSAGE_COOKIE_KEY);
        if (!idsWithHashes) {
            return {};
        }
        // Parse the cookie back into an object for easy lookup (_id -> hash)
        var messageMap = {};
        decodeURIComponent(idsWithHashes)
            .split(':')
            .forEach(function (entry) {
            var _a = entry.split('#'), id = _a[0], hash = _a[1];
            if (id && hash) {
                messageMap[id] = hash;
            }
        });
        return messageMap; // Return an object of `_id -> hash`
    }
    function generateHashSync(message) {
        return CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
    }
    function updateMessageList(msgList) {
        var readMessages = getReadMsgs(); // This will return an object with `_id -> hash`
        var showNotificationModal = false;
        ctrl.messages.list = msgList
            .map(function (msg) {
            // Concatenate message and title for hash generation
            var concatenatedMessage = msg.message + msg.title; // Combine message and title
            var storedHash = readMessages[msg._id]; // Get the stored hash for the message's `_id`
            var currentHash = generateHashSync(concatenatedMessage); // Generate the current hash of the concatenated string
            // Determine if the message is read based on the presence of `_id` in the cookie
            msg.hasRead = storedHash !== undefined; // If the hash exists in the cookie, it's marked as read
            // Determine if the message has been updated based on the hash comparison
            msg.hasUpdated = storedHash && storedHash !== currentHash;
            // If the message is not marked as read, trigger the notification modal
            if (!msg.hasRead || msg.hasUpdated) {
                showNotificationModal = true;
            }
            return msg;
        })
            .sort(function (a, b) {
            // Prioritize unread messages first
            if (!a.hasRead && !b.hasRead) {
                // If both are unread, prioritize new over updated
                if (!a.hasUpdated && b.hasUpdated) {
                    return -1; // `a` is new, `b` is updated
                }
                else if (a.hasUpdated && !b.hasUpdated) {
                    return 1; // `a` is updated, `b` is new
                }
                else {
                    return 0; // Both are the same (new or updated)
                }
            }
            else if (!a.hasRead) {
                return -1; // `a` is unread, `b` is read
            }
            else if (!b.hasRead) {
                return 1; // `b` is unread, `a` is read
            }
            else {
                return 0; // Both are read
            }
        });
        // Show the modal if there are unread messages
        $timeout(function () {
            var modal = $('#broadcastModal');
            if (showNotificationModal && !modal.hasClass('in')) {
                modal.modal('show');
            }
        });
    }
    // function updateMessageList(msgList) {
    //     const readMessages = getReadMsgs().split(':');
    //     let showNotificationModal = false;
    //     ctrl.messages.list = msgList.map((msg) => {
    //         msg.hasRead = readMessages.indexOf(msg._id) >= 0;
    //         if (!msg.hasRead) {
    //             showNotificationModal = true;
    //         }
    //         return msg;
    //     }).sort((a, b) => {
    //         if (a.hasRead) {
    //             return 1;
    //         } else if (b.hasRead) {
    //             return -1;
    //         } else {
    //             return 0;
    //         }
    //     });
    //     $timeout(() => {
    //         const modal = $('#broadcastModal');
    //         if (showNotificationModal && !modal.hasClass('in')) {
    //             modal.modal('show');
    //         }
    //     });
    // }
    /**
     * Why not use smartorg api lib:
     * That will renew the token every time, so it will never session time out.
     */
    function fetchMessage() {
        var endpoint = ctrl.smartorgApi.protocols.endpoint_;
        var path = ctrl.smartorgApi.protocols.path1;
        var url = path ? endpoint + "/" + path : endpoint;
        var fullRequestUrl = url + "/framework/broadcast/messages/list";
        var req = {
            method: 'POST',
            url: fullRequestUrl,
            headers: {
                Authorization: ctrl.smartorgApi.protocols.createAuthString()
            },
            data: {}
        };
        $http(req)
            .then(function (response) {
            updateMessageList(response.data.data);
        })["catch"](function (err) {
            if (err.status < 0 || err.status === 403) {
                clearTimers();
            }
            else {
                showAlert(ERROR_MESSAGE, 'Error ' + err.status, err);
            }
        });
    }
    function pollMessages() {
        clearTimers();
        fetchMessage();
        var timer = setInterval(function () {
            console.log('Start fetching!', timer);
            fetchMessage();
        }, INTERVAL_TIME_MILLISEC);
        intervalHanles.push(timer);
    }
    window.onunload = function (e) {
        clearTimers();
    };
}
angular.module('smartorg.r6.mgmts.broadcastMessagesView', []).component('broadcastMessagesView', {
    template: require('../../template/template.html'),
    controller: BroadcastMessageViewContrller,
    bindings: {
        smartorgApi: '<',
        showAlert: '&',
        username: '@'
    }
});
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.broadcastMessagesView';
//# sourceMappingURL=component.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/broadcast-messages-view/app/js/plumbing/component.js